import { Directive, OnInit, OnDestroy, Input, Injectable, Inject, Optional, forwardRef } from '@angular/core';
import { DataBindingDirective, GridComponent } from '@progress/kendo-angular-grid';
import { Subscription } from 'rxjs';
import { ArtikelService } from '../odata-services';
import { ArtikelDataService } from '../data-services';
import { ODataBindingDirective } from './core/o-data-binding-directive';
import { ODataEntitySetResource } from 'angular-odata';

@Injectable()
@Directive({
    selector: '[artikelBinding]'
})
export class ArtikelBindingDirective extends ODataBindingDirective {

    @Input('artikelBinding') query:  ODataEntitySetResource<any>;
    
    constructor(  @Inject(forwardRef(() => ArtikelDataService)) dataService: ArtikelDataService, @Inject(forwardRef(() => GridComponent))  grid: GridComponent) {
        super(dataService,grid);
    }
    public ngOnChanges( c: any ) : void {
 
        console.log( "Base-Query:", this.query);
        this.rebind();
    }

    
}